import type { ScrapMixFilterOption } from "../models";

const splitName = (name: string) => name.trim().split(/\s+/).filter(Boolean);

const toInitials = (parts: string[]) =>
  `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();

const toFirstNameWithLastInitial = (parts: string[]) =>
  `${parts[0]} ${parts[parts.length - 1][0].toUpperCase()}.`;

const countOccurrences = (keys: string[]) => {
  const counts = new Map<string, number>();
  for (const key of keys) counts.set(key, (counts.get(key) ?? 0) + 1);
  return counts;
};

export const buildOperatorChipLabels = (options: ScrapMixFilterOption[]) => {
  const operators = options
    .filter((option) => option.FilterType === "Operator")
    .map((option) => {
      const parts = splitName(option.Label);
      const hasFullName = parts.length > 1;
      return {
        value: option.Value,
        fullName: option.Label,
        initials: hasFullName ? toInitials(parts) : option.Label,
        shortName: hasFullName
          ? toFirstNameWithLastInitial(parts)
          : option.Label,
      };
    });

  const initialsCount = countOccurrences(
    operators.map((item) => item.initials),
  );
  const shortNameCount = countOccurrences(
    operators.map((item) => item.shortName),
  );

  return new Map(
    operators.map((operator) => {
      if (initialsCount.get(operator.initials) === 1)
        return [operator.value, operator.initials];
      if (shortNameCount.get(operator.shortName) === 1)
        return [operator.value, operator.shortName];
      return [operator.value, operator.fullName];
    }),
  );
};
